import { render } from "./Reminders.vue?vue&type=template&id=014fe7e9&scoped=true"
import script from "./Reminders.vue?vue&type=script&lang=js"
export * from "./Reminders.vue?vue&type=script&lang=js"

import "./Reminders.vue?vue&type=style&index=0&id=014fe7e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-014fe7e9"]])

export default __exports__